import { xMaxValue } from "./xMaxValue.js";
import { xRolling } from "./xRolling.js";
/**
 * This function calculates a maximum within a rolling window
 * @param array - array
 * @param options - options
 */
export function xRollingMax(array, options = {}) {
    return xRolling(array, xMaxValue, options);
}
//# sourceMappingURL=xRollingMax.js.map